import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { AppState } from '../../store';
import { selectAccountId } from '../../account/store/account.selectors';
import { Member } from '../members.models';
import { QueryParams } from '../../models/http.models';

@Injectable({
  providedIn: 'root',
})
export class MembersResource {
  private apiRoot: string = `${process.env.API_URL}`;

  constructor(private http: HttpClient, private store: Store<AppState>) {}

  get(member_id: number, params?: QueryParams): Observable<Member> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.get<Member>(`${this.apiRoot}/${account_id}/api/members/${member_id}`, { params }),
      ),
    );
  }

  save(body: Partial<Member>, params?: QueryParams): Observable<Member> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) => this.http.post<Member>(`${this.apiRoot}/${account_id}/api/members`, body, { params })),
    );
  }

  update(member_id: number, body: Member, params?: QueryParams): Observable<Member> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.put<Member>(`${this.apiRoot}/${account_id}/api/members/${member_id}`, body, { params }),
      ),
    );
  }

  remove(member_id: number, params?: QueryParams): Observable<any> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.delete<Member>(`${this.apiRoot}/${account_id}/api/members/${member_id}`, { params }),
      ),
    );
  }

  query(params?: QueryParams): Observable<Member[]> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) => this.http.get<Member[]>(`${this.apiRoot}/${account_id}/api/members`, { params })),
    );
  }

  search(params?: QueryParams): Observable<Member[]> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) => this.http.get<Member[]>(`${this.apiRoot}/${account_id}/api/members/search`, { params })),
    );
  }
}

((window as any).xplenty as angular.IModule).service('Member', downgradeInjectable(MembersResource));
